// Mini Cart JS

StyleHatch['utils'] = StyleHatch.utils || [];

StyleHatch.utils.imageSrcsetGenerator = (src) => {
  const sizes = [48, 90, 112, 256, 320, 480, 640, 750, 828, 1080, 1200, 1920, 2048, 3840];
  const updatedImages = sizes.map(size => {
    return `${src}&width=${size} ${size}w`
  })

  return updatedImages.join(',');
}

const MiniCartYmal = (container) =>{
  const jsonObject = JSON.parse(container.querySelector('[data-product-json]').innerHTML);
  const singleOptionSelectors = container.querySelectorAll('[data-single-option-selector]');
  const addToCartButton = container.querySelector('[data-ymal-atc]');
  const productId = container.querySelector('[data-ymal-product-id]');
  const productPrice = container.querySelector('[data-ymal-product-price]');
  const productImage = container.querySelector('[data-image-container] img');
  let variant = jsonObject.variants.filter(variant => {
    return variant.id === productId.value;
  })


  const updateProductVariant = () => {
    const newVariant = jsonObject.variants.find(loopVariant => {
      let matchedOptions = 0;

      singleOptionSelectors.forEach(option => {
        if(loopVariant[option.name] === option.value) matchedOptions++;
      })

      return matchedOptions == singleOptionSelectors.length;
    })

    productId.value = newVariant.id;
    variant = newVariant;
    productId.dispatchEvent(new Event('change'));
  }

  const onVariantChange = () => {
    updateImage();
    updateAddToCartStatus();
    updateProductPrice();
  }

  const updateImage = () => {
    if(variant.featured_image) {
      productImage.src = variant.featured_image.src;
      productImage.srcset = StyleHatch.utils.imageSrcsetGenerator(variant.featured_image.src);
    }
  }

  const updateProductPrice = () => {
    productPrice.value = `$${variant.price / 100}`;
  }

  const updateAddToCartStatus = () => {
    if(variant.available) {
      addToCartButton.style.opacity = 1;
      addToCartButton.style.pointerEvents = '';
      addToCartButton.disabled = false;
    } else {
      addToCartButton.style.opacity = 0.5;
      addToCartButton.style.pointerEvents = 'none';
      addToCartButton.disabled = true;
    }
  }

  const addUpsellToCart = () => {
    const event = new CustomEvent('ajaxCart:addFromId', {detail: {
      id: productId.value
    }})
    document.dispatchEvent(event);
  }

  singleOptionSelectors.forEach(singleOptionSelector => {
    singleOptionSelector.addEventListener('change', updateProductVariant);
  })

  productId.addEventListener('change', onVariantChange);
  addToCartButton.addEventListener('click', addUpsellToCart);
}

const SizeGuide = () =>{
  const container = document.querySelector(`[data-section-type="size-guide-section"]`);

  const attachEvent = () => {
    document.addEventListener('click', handleClickTab);
  }

  const handleClickTab = (event) => {
    const tabButton = event.target.closest(`[data-tab-index]`);
    const tabIndex = tabButton && tabButton.dataset.tabIndex;

    const tabContent = tabIndex && document.querySelector(`[data-tab-content-index="${tabIndex}"]`);
    const container = event.target.closest(`[data-section-type="size-guide-section"]`);
    const tabButtons = container && [...container.querySelectorAll(`[data-tab-index]`)];
    const tabContents = container && [...container.querySelectorAll(`[data-tab-content-index]`)];

    if(tabIndex) {
      tabButtons && tabButtons.map((tab) => tab.classList.remove('active'));
      tabContents && tabContents.map((tabC) => tabC.classList.remove('active'));
      tabButton && tabButton.classList.add('active');
      tabContent && tabContent.classList.add('active');
    }

  }

  if (container) {
    attachEvent();
  }
}

(function() {

  if (StyleHatch.enableMiniCart == true) {
    const selectors = {
      miniCart: '[data-mini-cart]',
      cartToggle: '[data-cart-toggle]',
      cartClose: '[data-cart-close]',
      cartCount: '[data-cart-count]',
      cartBody: '[data-cart-body]',
      cartBodyContent: '[data-cart-body-content]',
      giftVariantSelector: '[data-gift-variant-selector]',
      addToCartForm: '[data-AddToCartForm] > form',
      addToCartButton: '[data-AddToCartForm] > [data-addtocart]',
      quantityAdjust: '[data-quantity-adjust]',
      quantityWrapper: '[data-quantity-wrapper]',
      quantitySelector: '[data-quantity-selector]',
      removeItem: '[data-remove-item]',
    };
    const classes = {
      open: 'is-open',
    }
    let isLoading = false;
    StyleHatch.AjaxCart.init = function() {
      this.miniCart = document.querySelector(selectors.miniCart);
      this.cartBody = this.miniCart.querySelector(selectors.cartBody);
      this.updateCart.call(this);
      document.querySelector(selectors.cartToggle).addEventListener('click', this.openCart.bind(this));
      const $cartClose = document.querySelectorAll(selectors.cartClose);

      $cartClose.forEach(element => {
        element.addEventListener('click', this.closeCart.bind(this));
      });

      const $forms = document.querySelectorAll(selectors.addToCartForm);
      if ($forms.length) {
        $forms.forEach(element => {
          element.addEventListener('submit', this.addFromForm.bind(this));
        })
      }

      document.addEventListener('ajaxCart:addFromId', this.addFromId.bind(this));
    }
    StyleHatch.AjaxCart.addFromId = function(evt) {
      const id = evt.detail.id;
      if(!id) {
        console.error('[Ajax Cart] Add to cart from id: id value is required');
        return;
      }

      isLoading = true;
      this.miniCart.classList.add('is-loading');

      fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          id: evt.detail.id,
          quantity: evt.detail.quantity || 1,
        })
      })
      .then(response => response.json())
      .then(() => {
          this.updateCart.call(this, true);
        }
      )
      .catch((error) => {
        console.error(`[Ajax Cart] Add to cart from id: ${error}`)
      })
    }
    StyleHatch.AjaxCart.addFromForm = function(evt) {
      evt.preventDefault();
      evt.stopPropagation();

      if (isLoading == true) {
        return;
      }

      this.miniCart.classList.add('is-loading');

      const form = evt.target;
      const formData = new FormData(form);
      const objectData = Object.fromEntries(formData.entries());
      if (form.querySelector('.preorder-description')) {
        objectData.properties = {
          "_preorder": true,
          "Preorder": form.querySelector('.preorder-description').innerText || ""
        }
      }

      if(form.querySelector('.product-note')) {
        objectData.properties = {
          ...objectData.properties,
          "Note": form.querySelector('.product-note').innerText || ""
        }
      }
      fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(objectData)
      }).then(response => {
        return response.json();
      }).then(response => {
        this.updateCart.call(this, true);
      })
        .catch((error) => {
          console.error('Error: ', error);
        })
    }
    StyleHatch.AjaxCart.updateCartQuantity = function() {
      const $bodyContent = this.cartBody.querySelector(selectors.cartBodyContent);
      const cartCount = $bodyContent.dataset.itemsTotal;
      const total = $bodyContent.dataset.cartSubtotal;

      document.querySelectorAll(selectors.cartCount).forEach(element => {
        element.innerText = cartCount;
      })

      document.getElementById('CartCost').innerText = total;
    }
    StyleHatch.AjaxCart.updateCart = function(open) {
      fetch('/cart?view=mini-cart', {
        method: 'GET',
      }).then(response => {
        return response.text();
      }).then(response => {
        this.cartBody.innerHTML = response;
        this.bindEditEvents.call(this);
        this.updateCartQuantity.call(this);
        if (open) {
          this.openCart();
        }

        StyleHatch.Cart.updateFreeGift.call(this, null, StyleHatch.AjaxCart.updateCart);

        const ymalItems = this.cartBody.querySelectorAll('[data-product-ymal]');

        if(ymalItems.length) {
          ymalItems.forEach((item) => {
            MiniCartYmal(item);
          })
        }

        isLoading = false;
        this.miniCart.classList.remove('is-loading');

      })
    }
    StyleHatch.AjaxCart.closeCart = function() {
      document.querySelector('body').style.overflowY = '';
      document.querySelector(selectors.miniCart).classList.remove(classes.open)
    }
    StyleHatch.AjaxCart.openCart = function(evt) {
      if (evt) {
        evt.preventDefault();
      }
      document.querySelector('body').style.overflowY = 'hidden';
      document.querySelector(selectors.miniCart).classList.add(classes.open)
    }
    StyleHatch.AjaxCart.removeItem = function(evt) {
      const key = evt.target.dataset.removeItem;
      isLoading = true;
      this.miniCart.classList.add('is-loading');

      let updates = {};

      updates[key] = 0;

      if (key.includes(',')) {
        let keys = key.split(',');

        keys.forEach((key) => {
          updates[key] = 0;
        });
      }

      fetch('/cart/update.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({ updates })
      }).then(() => {
        this.updateCart();
      })
    }
    StyleHatch.AjaxCart.bindEditEvents = function() {
      this.miniCart.querySelectorAll(selectors.quantityAdjust).forEach(element => {
        element.addEventListener('click', this.changeLineQuantity.bind(this));
      })
      this.miniCart.querySelectorAll(selectors.quantitySelector).forEach(element => {
        element.addEventListener('change', this.updateLineQuantity.bind(this));
      })
      this.miniCart.querySelectorAll(selectors.removeItem).forEach(element => {
        element.addEventListener('click', this.removeItem.bind(this));
      })
      const variantSelector = this.miniCart.querySelector(selectors.giftVariantSelector);
      if (variantSelector) {
        variantSelector.addEventListener('change', StyleHatch.Cart.changeGiftProduct.bind(this));
      }
    }
    StyleHatch.AjaxCart.removeEditEvents = function() {
      this.miniCart.querySelectorAll(selectors.quantityAdjust).forEach(element => {
        element.removeEventListener('click', this.changeLineQuantity);
      })
      this.miniCart.querySelectorAll(selectors.quantitySelector).forEach(element => {
        element.removeEventListener('change', this.updateLineQuantity);
      })
      this.miniCart.querySelectorAll(selectors.removeItem).forEach(element => {
        element.removeEventListener('click', this.removeItem);
      })
      const variantSelector = this.miniCart.querySelector(selectors.giftVariantSelector);
      if (variantSelector) {
        variantSelector.removeEventListener('change', StyleHatch.Cart.changeGiftProduct.bind(this));
      }
    }
    StyleHatch.AjaxCart.changeLineQuantity = function(evt) {
      const $this = evt.currentTarget;
      const $qtyInput = $this.closest('[data-quantity-wrapper]').querySelector('[data-quantity-selector]');

      if ($this.dataset.quantityAdjust == 'minus') {
        $qtyInput.value = parseInt($qtyInput.value) - 1;
      } else {
        $qtyInput.value = parseInt($qtyInput.value) + 1;
      }

      $qtyInput.dispatchEvent(new CustomEvent('change'));
    }
    StyleHatch.AjaxCart.updateLineQuantity = function(evt) {
      const $this = evt.currentTarget;
      const key = $this.dataset.lineKey;
      const max = parseInt($this.max);
      let quantity = parseInt($this.value)

      if (quantity > max) {
        quantity = max;
      }
      this.miniCart.classList.add('is-loading');

      fetch('/cart/update.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: `{"updates": {"${key}": ${quantity}}}`
      }).then(() => {
        this.updateCart();
      })
    }
  }

  if($('.cart-template').length) {
    StyleHatch.Cart = function() {
      StyleHatch.Cart.quantitySelect();
      $('[data-quantity-selector]').on('change', StyleHatch.Cart.updateLineQuantity);
      $('[data-gift-variant-selector]').on('change', StyleHatch.Cart.changeGiftProduct);
      $('[data-update-order-notes]').on('click', StyleHatch.Cart.updateOrderNotes);
      StyleHatch.Cart.initializeUpsell();
    }
    StyleHatch.Cart.updateLineQuantity = function(evt) {
      const $this = evt.currentTarget;
      const key = $this.dataset.lineKey;
      let quantity = parseInt($this.value);
      let max = parseInt($this.max);

      if (quantity > max) {
        $this.value = max;
        quantity = max;
        return;
      }

      fetch('/cart/update.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: `{"updates": {"${key}": ${quantity}}}`
      }).then((res) => {
        StyleHatch.Cart.updateCart();

        StyleHatch.Cart.updateFreeGift(null, StyleHatch.Cart.updateCart);
      })
    }
    StyleHatch.Cart.quantitySelect = function () {
      $('[data-quantity-selector-container]').each((index, item)=> {
        var $plusBtn = $('[data-quantity-plus]', item);
        var $minusBtn = $('[data-quantity-minus]', item);
        var $quantitySelector = $('[data-quantity-selector]', item);
        $minusBtn.on('click', (evt) => {
          evt.preventDefault();
          if($quantitySelector.val() - 1 >= 1) {
            $quantitySelector.val(parseInt($quantitySelector.val()) - 1);
            $quantitySelector.trigger('change');
          }
        })

        $plusBtn.on('click', (evt) => {
          evt.preventDefault();
          $quantitySelector.val(parseInt($quantitySelector.val()) + 1);
          $quantitySelector.trigger('change');
        })
      })
    }
    StyleHatch.Cart.updateCart = function() {
      fetch(`https://${document.location.host}/cart`).then((res) => {
        return res.text();
      }).then((res) => {
        let html = $(res);
        $('.cart__wrapper').replaceWith(html.find('.cart__wrapper'));
        $('#CartCost').html(html.find('#CartCost').html());
        $('#CartCount .pplr_cart_count').html(html.find('#CartCount .pplr_cart_count').html());
        StyleHatch.Cart();
      })
    }
    StyleHatch.Cart.initializeUpsell = function() {
      $('.cart__upsell-cards-container').slick({
        slidesToShow: 2.1,
        slide: '.upsell_product',
        centerMode: false,
        infinite: false,
        prevArrow: '.cart__upsell-container [data-arrow-prev]',
        nextArrow: '.cart__upsell-container [data-arrow-next]',
        dots: true,
      })
    }
    StyleHatch.Cart.updateOrderNotes = function() {
      var orderNotes = $('[data-order-notes]').val();
      console.log(orderNotes);
      fetch('/cart/update.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({note: orderNotes})
      }).then(() => {
        StyleHatch.Cart.updateCart();
      })
    }
  }

  StyleHatch.Cart.updateFreeGift = function(id, callback) {
    fetch('/cart.json', {
      method: 'GET'
    })
      .then(result => result.json())
      .then(cart => {
        let giftPresent = false;
        let removeGift = false;

        let newCartList = [];
        cart.items.forEach((item) => {
          if (!item.properties['_freeGift']) {
            newCartList.push({
              id: item.id,
              quantity: item.quantity,
              properties: item.properties,
            })
          } else {
            giftPresent = true;
          }
        })

        // Gift is present and cart price doesn't meet threshold, remove gift
        if (giftPresent && cart.total_price / 100 < GiftManager?.data?.threshold) {
          removeGift = true;
        }

        // Gift is present and no gift was configured nor being passed to the function, remove gift
        if (giftPresent && (!GiftManager?.data?.id && !id)) {
          removeGift = true;
        }

        // Gift is present, cart matches threshold and no new id needs to be added, skips execution
        if (!removeGift && giftPresent && !id) {
          return false;
        }

        // Gift is not present and is not needed, skips execution
        if (!giftPresent && cart.total_price / 100 < GiftManager?.data?.threshold) {
          return false;
        }

        // Gift is not present or new gift ID is added to cart
        if (!removeGift && (id || GiftManager?.data?.id)) {
          newCartList.push({
            id: id || GiftManager.data.id,
            quantity: 1,
            properties: {
              '_freeGift': true
            }
          })
        }

        if(newCartList.length !== cart.items.length) {
          isLoading = true;
          if(this.miniCart) {
            this.miniCart.classList.add('is-loading');
          }
          fetch('/cart/clear', { method: 'POST' })
          .then(() => {
            fetch("/cart/add.js", {
              method: "POST",
              headers: {
                "Content-Type": "application/json",
              },
              body: JSON.stringify({ items: newCartList }),
            }).then(() => {
              callback.call(this);
            });
          });
        }
      })
  }

  StyleHatch.Cart.changeGiftProduct = async function(evt) {
    const newId = parseInt(evt.currentTarget.value);
    const currentCartData = await fetch('/cart.json').then(response => { return response.json() }).then(response => { return response; });
    const newData = [];

    if(this.miniCart) {
      isLoading = true;
      this.miniCart.classList.add('is-loading');
    }

    currentCartData.items.map((item) => {
      if (item.properties?._freeGift) {
        return false;
      } else {
        newData.unshift({
          id: item.id,
          quantity: item.quantity,
          properties: item.properties,
        })
      }
    })

    newData.push({
      id: newId,
      quantity: 1,
      properties: {
        _freeGift: true,
      },
    })

    fetch('/cart/clear').then(() => {
      fetch('/cart/add', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({ items: newData })
      }).then(() => {
        if($('.template-cart').length > 0) {
          StyleHatch.Cart.updateCart();
        } else {
          StyleHatch.AjaxCart.updateCart();
        }
      })
    })
  }

  if($('.template-cart').length === 0) {
    StyleHatch.enableMiniCart && StyleHatch.AjaxCart.init();
  }

  if ($('.template-collection').length) {
    const throttle = (fn, delay) => {
      // Capture the current time
      let time = Date.now();

      // Here's our logic
      return () => {
        if ((time + delay - Date.now()) <= 0) {
          // Run the function we've passed to our throttler,
          // and reset the `time` variable (so we can check again).
          fn();
          time = Date.now();
        }
      }
    }

    const windowLoad = () => {
      const $el = $('.pagination-top');
      const offsetTop = $el.offset().top;
      const headerHeight = $('header.util').outerHeight();

      const checkPagination = () => {
        if ($(this).width() > 768) return

        const isPositionFixed = ($el.closest('.collection-header').hasClass('stick-pagination'));

        if ($(this).scrollTop() > (offsetTop - (headerHeight + 12)) && !isPositionFixed) {
          $el.css('top', headerHeight);
          $el.closest('.collection-header').addClass('stick-pagination');
        } else if ($(this).scrollTop() < (offsetTop - (headerHeight + 12)) && isPositionFixed) {
          $el.closest('.collection-header').removeClass('stick-pagination');
        }
      }

      $(window).on('scroll', throttle(checkPagination, 10));
      checkPagination();
    }

    $(window).on('load', windowLoad)
  }

  if ($('.template-product').length) {
    var $bisPhoneField = $('[data-bis-phone-field]');
    var $bisPhoneSubmit = $('[data-bis-phone]');

    $bisPhoneField.on('keyup', updatePhoneStructure);
    $bisPhoneSubmit.on('click', bisPhone);

    function updatePhoneStructure(evt) {
      var $this = $(evt.currentTarget);
      var match = $this.val().replace(/\+1/g, '').replaceAll(/[^0-9]+/g, '')
      if (match) {
        var part1 = match.length > 3 ? `(${match.substring(0, 3)})` : `(${match}`;
        var part2 = match.length > 3 ? ` ${match.substring(3, 6)}` : '';
        var part3 = match.length > 6 ? `-${match.substring(6, 10)}` : '';

        $this.val(`${part1}${part2}${part3}`);
      }
    }

    function smsCallback(data) {
      var msg = "";

      if ("OK" == data.status) {
        msg = data.message;
        $(".reorder-form .confirmation").text(msg).show();
      } else {
        console.log(data.errors);
        for (var error in data.errors) {
          msg += data.errors[error].join();
          $(".reorder-form .confirmation").addClass("error").text(msg).show();
        }
      }
    }

    function bisPhone(evt) {
      evt.preventDefault();

      var acceptsMarketing = $("#accepts_marketing").is(":checked");
      var sms = '+1' + $('#notify_sms').val().replaceAll(/[^0-9]+/g, '');
      var productId = $('.reorder-form').attr('data-productid');
      var variantId = $('.reorder-form').attr('data-variantid');

      BIS.create(null, variantId, productId, { accepts_marketing: acceptsMarketing, phone_number: sms }).then(smsCallback); // create the notification

      // Post phone number to Klaviyo list
      if (!acceptsMarketing) {
        return;
      }
      console.log('should submitt to klaviyo');
      $.ajax({
        url: 'https://a.klaviyo.com/client/subscriptions/?company_id=LQViUK',
        method: 'POST',
        headers: {
          'accepts': 'application/json',
          'content-type': 'application/json',
          'cache-control': 'no-cache',
          'revision': '2024-02-15',
        },
        data: JSON.stringify({
          data: {
            type: 'subscription',
            attributes: {
              custom_source: 'PDP BIS form',
              profile: {
                data: {
                  type: "profile",
                  attributes: {
                    phone_number: sms,
                  }
                }
              }
            },
            relationships: {
              list: {
                data: {
                  type: 'list',
                  id: 'WDN6a4'
                }
              }
            }
          }
        })
      })
      .done( function(data) {
        console.log('SMS consent submitted');
      })
    }
  }

  SizeGuide();
})();